'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// converting text from camel case
const toSnake = key => key.replace(/([a-z\d])([A-Z])/g, '$1_$2').toLowerCase();
var decamelize = (camelKey, value) => {
  const snakeKey = toSnake(camelKey);
  if (!Array.isArray(value)) return [snakeKey, value];
  const nestedValue = value.map(payloadItem => {
    if (!payloadItem || typeof payloadItem !== 'object') return payloadItem;
    return Object.entries(payloadItem).reduce((acc, [payloadCamelKey, payloadValue]) => {
      acc[toSnake(payloadCamelKey)] = payloadValue;
      return acc;
    }, {});
  });
  return [snakeKey, nestedValue];
};

exports["default"] = decamelize;
